<template>
  <div id="publishing-affiliations-add">
    <ipub-model :title="'Variable'"
                width="900px"
                :visable="isVisable"
                @confirm="confirm"
                confirmText="Confirm"
                @cancel="cancel">
      <site-search-group class="mar-b-40"
                         v-model.trim="search"
                         placeholder="Search by variable name"
                         @search="getList()"
                         @clear="handleClear" />
      <div class="mar-b-60">
        <ipub-label :style="{margin: '0 16px 16px 0'}"
                    class="ipub-cursor-pointer"
                    v-for="(item, index) in dataSource"
                    :key="'dataSource'+index"
                    size="common"
                    @click="onChoChange(item)"
                    :active="cho === item.variable"
                    circle>{{item.name}}</ipub-label>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import SiteSearchGroup from '@/components/search-group.vue'
import help from '@/utils/help'
import { mailVariable } from '@/api/mail'
import { mapGetters } from 'vuex'
export default {
  components: { SiteSearchGroup },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      dataSource: ['111', '2222', '3333'],
      cho: '',
      search: ''
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.search = ''
      }
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      this.dataSource = await mailVariable.getAll({ name: this.search })
    },
    async confirm () {
      help.copyToBlock('${' + this.cho + '}')
      this.$message.success({
        title: 'Success',
        content: 'The Variable has been copied to the clipboard!'
      })
      this.$emit('confirm', this.params)
    },
    handleClear () {
      this.search = ''
      this.getList()
    },
    onChoChange (val) {
      this.cho = val.variable
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
